(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9603],{

/***/ 27646:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search",
      function () {
        return __webpack_require__(87353);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 57416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64384);
/* harmony import */ var _api_baskets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18682);
/* harmony import */ var _common_splicePrice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8025);
/* harmony import */ var _redux_action_cart__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(68866);
/* harmony import */ var _redux_action_quickViewAction__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(43181);
/* harmony import */ var _redux_action_alert__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4557);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _redux_action_baskets__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83173);
/* harmony import */ var _common_auth__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48106);
/* harmony import */ var _SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(74971);
/* harmony import */ var _api_products__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(81628);
/* harmony import */ var _common_helper__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(11769);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

















var SingleProduct = function(param) {
    var product1 = param.product, basketsItems = param.basketsItems, cartItems = param.cartItems, basketsCount = param.basketsCount, _$addToCart = param.addToCart, addToWishlist = param.addToWishlist, _$openQuickView = param.openQuickView, _$increaseCnt = param.increaseCnt, _$showToastAlert = param.showToastAlert, _$insertBasketsAction = param.insertBasketsAction, _$fetchBasketsAction = param.fetchBasketsAction, dummyList = param.dummyList, addCart = param.addCart, inCart = param.inCart, index = param.index;
    var inBasket = inCart ? inCart(product1) : (basketsItems === null || basketsItems === void 0 ? void 0 : basketsItems.find(function(basketsItem) {
        return basketsItem.pcode === product1.pcode;
    })) || (cartItems === null || cartItems === void 0 ? void 0 : cartItems.find(function(cartItem) {
        return cartItem.pcode === product1.pcode;
    }));
    // orderType 이 'O' 이거나 없으면 일반 구매 가능 상품
    var isOrderTypeO = !product1.orderType || product1.orderType === "O";
    var handleCart = function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(product) {
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (product) {
                            dataLayer.push({
                                ecommerce: null
                            }); // Clear the previous ecommerce object.
                            dataLayer.push({
                                event: "add_to_cart",
                                ecommerce: {
                                    items: [
                                        {
                                            item_name: product.pname,
                                            item_id: product.pcode,
                                            price: product.price,
                                            item_brand: product.supplier,
                                            item_category: product.category_code.length > 2 ? product.category_code : dummyList === null || dummyList === void 0 ? void 0 : dummyList.category[product.category_code]
                                        }, 
                                    ]
                                }
                            });
                            // 채널톡 장바구니 이벤트
                            window.ChannelIO("track", "AddToCart", {
                                pcode: product.pcode
                            });
                        }
                        if ((0,_common_auth__WEBPACK_IMPORTED_MODULE_9__/* .getCookie */ .ej)("token")) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return", _$addToCart(product));
                    case 5:
                        return _ctx.abrupt("return", _$insertBasketsAction(product, 1));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleCart(product) {
            return _ref.apply(this, arguments);
        };
    }();
    var moveToDetail = function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var body;
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "ViewCount",
                            pcode: product1.pcode
                        };
                        _ctx.next = 3;
                        return (0,_api_products__WEBPACK_IMPORTED_MODULE_11__/* .ViewCountProduct */ .Ir)(body);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function moveToDetail() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .Wrapper */ .im, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .ProductImgWrapper */ .Q5, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/products/".concat(product1 === null || product1 === void 0 ? void 0 : product1.ename, "/").concat(product1.pcode, "/"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .ProductImgWrapper */ .Q5, {
                                onClick: moveToDetail,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                                    src: product1.main_image,
                                    alt: product1.pname || "\uC0C1\uD488 \uC774\uBBF8\uC9C0",
                                    layout: "fill",
                                    objectFit: "cover",
                                    sizes: "(max-width: 768px) 100vw, 33vw",
                                    priority: index === 0
                                })
                            })
                        }),
                        product1.sfnz_view === "Y" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .SfnzBadge */ .L4, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                src: "https://file.caretbio.com/caretbio/75378c147862e82d7a9ede3651163fdd.png",
                                alt: "\uC2A4\uD15D\uD3EC\uB137\uC81C\uB85C \uCE5C\uD658\uACBD \uBC30\uC9C0"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .ProductContentWrapper */ .ZD, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/products/".concat(product1 === null || product1 === void 0 ? void 0 : product1.ename, "/").concat(product1.pcode, "/"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .ProductName */ .rZ, {
                                onClick: moveToDetail,
                                children: product1.pname
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .ProductBottomWrapper */ .qW, {
                            children: [
                                isOrderTypeO && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .PriceWrapper */ .vN, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .PriceBox */ .bz, {
                                        children: [
                                            product1.salePer > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                                        children: [
                                                            product1.salePer,
                                                            "%"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                        children: product1.price && " ".concat((0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_12__/* .priceComma */ .a)(product1.price), "\uC6D0")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "d-flex",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h5", {
                                                    children: [
                                                        (0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_12__/* .priceComma */ .a)(product1.discount_price),
                                                        "\uC6D0"
                                                    ]
                                                })
                                            }),
                                            Number(product1.quantity) > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                style: {
                                                    fontSize: "14px"
                                                },
                                                children: [
                                                    "\uAC1C\uB2F9",
                                                    " ",
                                                    (0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_12__/* .priceComma */ .a)(Math.floor(Number(product1.discount_price) / Number(product1.quantity))),
                                                    "\uC6D0"
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                product1.sold_out === "Y" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .CartIconBox */ .d4, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        children: "\uD488\uC808"
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .CartIconBox */ .d4, {
                                    children: isOrderTypeO && (!inBasket ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                        className: "mobonCart",
                                        onClick: function() {
                                            return addCart ? addCart(product1) : handleCart(product1);
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                            className: "fi-rs-shopping-cart-add"
                                        })
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                        onClick: function() {
                                            return addCart ? addCart(product1) : handleCart(product1);
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                            className: "fi-rs-shopping-cart-check"
                                        })
                                    }))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .StickerWrapper */ .Mo, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .ViewBox */ .HA, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        children: [
                                            (0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_12__/* .priceComma */ .a)((0,_common_helper__WEBPACK_IMPORTED_MODULE_13__/* .calcProdPoint */ .tB)((Number(String(product1.discount_price).replace(/[^\d.-]/g, "")) || 0) * 1)),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .Sticker */ .My, {
                                                children: "P"
                                            }),
                                            " \uC801\uB9BD"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                src: "/assets/imgs/theme/icons/icon-view.png",
                                                alt: "\uC870\uD68C\uC218 \uC544\uC774\uCF58"
                                            }),
                                            product1.hit
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var mapStateToProps = function(state) {
    return {
        cartItems: state.cart,
        basketsItems: state.baskets.items,
        basketsCount: state.baskets.count
    };
};
var mapDispatchToProps = {
    addToCart: _redux_action_cart__WEBPACK_IMPORTED_MODULE_14__/* .addToCart */ .Xq,
    openQuickView: _redux_action_quickViewAction__WEBPACK_IMPORTED_MODULE_15__/* .openQuickView */ .$,
    increaseCnt: _redux_action_cart__WEBPACK_IMPORTED_MODULE_14__/* .increaseCnt */ .us,
    showToastAlert: _redux_action_alert__WEBPACK_IMPORTED_MODULE_5__/* .showToastAlert */ .I,
    insertBasketsAction: _redux_action_baskets__WEBPACK_IMPORTED_MODULE_8__/* .insertBasketsAction */ .el,
    fetchBasketsAction: _redux_action_baskets__WEBPACK_IMPORTED_MODULE_8__/* .fetchBasketsAction */ .Ei
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .connect */ .$j)(mapStateToProps, mapDispatchToProps)(SingleProduct));


/***/ }),

/***/ 87353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ search; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/layout/Layout.js + 38 modules
var Layout = __webpack_require__(32511);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./components/search/Search.styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 50px 0;\n\n  .p_title {\n    width: 100%;\n    margin-bottom: 30px;\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    & div {\n      margin-bottom: 0px !important;\n    }\n    @media screen and (max-width: 1199px) {\n      display: none;\n    }\n  }\n\n  .m_title {\n    display: none;\n    @media screen and (max-width: 1199px) {\n      display: flex;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: 180px 1fr;\n  border-bottom: 1px solid #e5e7eb;\n\n  @media (max-width: 768px) {\n    grid-template-columns: 1fr; /* \uBAA8\uBC14\uC77C 1\uC5F4 */\n  }\n\n  .label {\n    background: #10b981;\n    color: #fff;\n    padding: 14px 16px;\n    font-weight: 700;\n  }\n  .content {\n    padding: 10px 16px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  font-size: 16px;\n  & span {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 10px 10px;\n    border: 1px solid #ececec;\n    cursor: pointer;\n  }\n\n  .selected {\n    background-color: #3bb77e;\n    color: white;\n    border: 1px solid #3bb77e;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  .cnt {\n    font-size: 16px;\n  }\n  .filter {\n    width: fit-content;\n  }\n\n  @media (max-width: 991px) {\n    display: flex;\n    flex-direction: column;\n    .cnt {\n      width: 100%;\n      margin-bottom: 10px;\n    }\n    .filter {\n      width: 100%;\n    }\n  }\n  @media (max-width: 767px) {\n    & span {\n      font-size: 14px;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 50px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  border-bottom: 1px solid #ececec;\n  padding-bottom: 20px;\n  margin-bottom: 20px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  grid-column-gap: 10px;\n  grid-row-gap: 20px;\n  margin-bottom: 20px;\n  min-width: 0;\n\n  @media (max-width: 1200px) {\n    grid-template-columns: repeat(4, 1fr);\n  }\n  @media (max-width: 991px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  @media (max-width: 767px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  word-break: keep-all;\n  margin-top: 50px;\n  margin-bottom: 30px;\n  & h4 {\n    margin-bottom: 20px;\n    text-align: center;\n  }\n  @media (max-width: 991px) {\n    & h4 {\n      font-size: 18px;\n    }\n    & a {\n      font-size: 14px;\n    }\n  }\n  @media (max-width: 767px) {\n    & h4 {\n      font-size: 16px;\n    }\n    & a {\n      padding: 5px 20px;\n      font-size: 12px;\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  color: #253d4e;\n  .header {\n    background-color: #f9f6f6ba;\n  }\n  & tr {\n    text-align: center;\n    :hover {\n      background-color: #f9f6f6ba;\n    }\n  }\n\n  & th {\n    padding: 5px;\n    font-size: 14px;\n    word-break: keep-all;\n  }\n\n  & td {\n    padding: 10px;\n  }\n\n  & a {\n    color: #253d4e;\n  }\n\n  .img {\n    width: 10%;\n    padding: 5px;\n    & a {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n  .name {\n    width: 15%;\n    & a {\n      overflow: hidden;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      white-space: pre-wrap;\n      text-overflow: ellipsis;\n      word-break: keep-all;\n      :hover {\n        color: #3bb77e;\n      }\n    }\n  }\n\n  .price {\n    color: #dc3545;\n  }\n\n  .btnWrapper {\n    width: 15%;\n  }\n\n  @media (max-width: 991px) {\n    & td {\n      padding: 5px;\n    }\n    .name { }\n    .golgi {\n      width: 7%;\n    }\n    .feature {\n      width: 15%;\n    }\n    .sizes {\n      width: 10%;\n    }\n    .onePrice {\n      width: 10%;\n    }\n    .quantity {\n      width: 10%;\n    }\n    .price {\n      width: 13%;\n    }\n  }\n  @media (max-width: 767px) {\n    & th {\n      font-size: 12px;\n    }\n    & td {\n      font-size: 12px;\n    }\n    .img {\n      display: none;\n    }\n    .golgi {\n      width: 7%;\n    }\n    .price {\n      width: 13%;\n    }\n  }\n  @media (max-width: 575px) {\n    & th {\n      font-size: 10px;\n    }\n    & td {\n      font-size: 10px;\n      padding: 5px;\n    }\n    .name {\n      width: 25%;\n    }\n    .sizes {\n      display: none;\n    }\n    .strength {\n      width: 10%;\n    }\n    .feature {\n      width: 10%;\n    }\n    .golgi { }\n    .onePrice { }\n    .quantity { }\n    .price { }\n  }\n  @media (max-width: 460px) {\n    .quantity {\n      display: none;\n    }\n    .onePrice {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-size: 14px;\n  word-break: keep-all;\n  @media (max-width: 991px) {\n    font-size: 14px;\n    line-height: 1.5;\n  }\n  @media (max-width: 767px) {\n    font-size: 10px;\n  }\n  @media (max-width: 575px) {\n    font-size: 8px;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: #fd7e14;\n  color: #fff;\n  border: 1px solid #fd7e14;\n  margin-bottom: 2px;\n  :hover {\n    opacity: 0.8;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  border: 1px solid #3bb77e;\n  :hover {\n    opacity: 0.8;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 0;\n\n  & > div {\n    & span {\n      text-decoration: line-through;\n      color: #6c757d;\n      opacity: 0.5;\n    }\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  grid-column-gap: 10px;\n  grid-row-gap: 20px;\n  margin-bottom: 20px;\n\n  @media (max-width: 1200px) {\n    grid-template-columns: repeat(4, 1fr);\n  }\n  @media (max-width: 991px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  @media (max-width: 767px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  /* \u2705 \uC544\uC8FC \uC791\uC740 \uD3ED\uC5D0\uC11C 1\uC5F4 */\n  @media (max-width: 520px) {\n    grid-template-columns: 1fr;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  cursor: pointer;\n  border: 1px solid #ececec;\n  border-radius: 10px;\n  padding-bottom: 20px;\n  overflow: hidden;\n  transition: 0.2s;\n\n  .thumbnail {\n    width: 100%;\n    margin-bottom: 10px;\n    & img {\n      display: block;          /* \u2705 \uBAA8\uBC14\uC77C \uC774\uBBF8\uC9C0 \uAC04\uD5D0\uC801 \uACF5\uBC31 \uBC29\uC9C0 */\n      width: 100%;             /* \u2705 \uAC00\uB85C 100% */\n      height: auto;\n      object-fit: cover;\n    }\n  }\n\n  .title {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 50px;\n\n    & h5 {\n      font-size: 20px;\n      word-break: keep-all;\n      overflow-wrap: anywhere; /* \u2705 \uAE38\uAC8C \uBD99\uC740 \uB2E8\uC5B4\uB3C4 \uC904\uBC14\uAFC8 */\n      margin-bottom: 10px;\n      padding: 0px 10px;\n      transition: 0.2s;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: normal;     /* \u2705 'wrap' \u2192 'normal' \uB85C \uC218\uC815 */\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      align-items: center;\n    }\n\n    @media (max-width: 991px) {\n      & h5 { font-size: 16px; }\n      height: 40px;\n    }\n    @media (max-width: 460px) {\n      & h5 { font-size: 14px; }\n      height: 34px;\n    }\n  }\n\n  .sub_title {\n    color: #58585f;\n    padding: 0px 20px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    @media (max-width: 991px) {\n      font-size: 16px;\n    }\n    @media (max-width: 460px) {\n      font-size: 12px;\n    }\n  }\n\n  :hover {\n    border-color: #3bb77e;\n    -webkit-box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);\n    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);\n\n    .title { color: #3bb77e; }\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  width: fit-content;\n  cursor: pointer;\n  background-color: #3bb77e;\n  padding: 10px 20px;\n  border-radius: 10px;\n  margin: auto;\n  color: #fff;\n\n  /* \u2705 \uBAA8\uBC14\uC77C\uC5D0\uC11C\uB294 \uD480\uD3ED\uC73C\uB85C \uD0ED \uD788\uD2B8\uBC15\uC2A4 \uD655\uB300 */\n  @media (max-width: 520px) {\n    width: 100%;\n    text-align: center;\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}

var Container = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-3849a310-0"
})(_templateObject());
/* ✅ 모바일에서 1열로 자동 전환되는 공통 필터 행 */ var FilterRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3849a310-1"
})(_templateObject1());
var ListViewTypeWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3849a310-2"
})(_templateObject2());
var ListViewSelectBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3849a310-3"
})(_templateObject3());
var FilterWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3849a310-4"
})(_templateObject4());
var ListWraper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3849a310-5"
})(_templateObject5());
var CategoryTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-3849a310-6"
})(_templateObject6());
var ProductsGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3849a310-7"
})(_templateObject7());
var ProductsList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3849a310-8"
})(_templateObject8());
var ProductsSignWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3849a310-9"
})(_templateObject9());
/* table type list */ var TableTypeWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3849a310-10"
})(_templateObject10());
var Table = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    componentId: "sc-3849a310-11"
})(_templateObject11());
var BtnWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3849a310-12"
})(_templateObject12());
var CheckoutBtn = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-3849a310-13"
})(_templateObject13());
var CartBtn = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-3849a310-14"
})(_templateObject14(), function(props) {
    return props.inCart ? "#3bb77e" : "#fff";
}, function(props) {
    return props.inCart ? "#fff" : "#3bb77e";
});
var PriceBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3849a310-15"
})(_templateObject15());
var SearchedCommunity = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3849a310-16"
})(_templateObject16());
var CommunityBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3849a310-17"
})(_templateObject17());
var MoreBtn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3849a310-18"
})(_templateObject18());

// EXTERNAL MODULE: ./components/ecommerce/singleProduct/SingleProduct.js
var SingleProduct = __webpack_require__(57416);
;// CONCATENATED MODULE: ./components/search/Search.presenter.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}




var INITIAL_PAGE = 16;
var PAGE_STEP = 16;
var SearchUI = function(param1) {
    var router = param1.router, viewType = param1.viewType, searchList = param1.searchList, dummyList = param1.dummyList, cateViewStats = param1.cateViewStats, moreProducts = param1.moreProducts, _suggestions = param1.suggestions, suggestions = _suggestions === void 0 ? [] : _suggestions, // ✅ 부모에서 주입되는 게시글 이동 함수
    moveToDetail = param1.moveToDetail;
    var ref11;
    var ref1;
    var productGroups = (ref1 = searchList === null || searchList === void 0 ? void 0 : searchList.data) !== null && ref1 !== void 0 ? ref1 : {};
    var hasData = productGroups && Object.keys(productGroups).length > 0;
    var hasCommunity = Array.isArray(searchList === null || searchList === void 0 ? void 0 : (ref11 = searchList.community) === null || ref11 === void 0 ? void 0 : ref11.data) && searchList.community.data.length > 0;
    // ===== 추천 키워드 클릭 -> 쿼리 업데이트 =====
    var handleSuggestClick = function(kw) {
        if (!kw) return;
        var _query = router.query, garo = _query.garo, sero = _query.sero, high = _query.high, erange = _query.erange, rest = _objectWithoutProperties(_query, [
            "garo",
            "sero",
            "high",
            "erange"
        ]);
        var next = _objectSpread({}, rest, {
            search: kw
        });
        // 로컬 필터 초기화
        setGaroInput("");
        setSeroInput("");
        setHighInput("");
        setSizeTol("30");
        router.push({
            pathname: "/search",
            query: next
        });
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    // ===== 상태 =====
    var ref2 = (0,react.useState)(""), innerKeyword = ref2[0], setInnerKeyword = ref2[1];
    var ref3 = (0,react.useState)([]), selectedTopCats = ref3[0], setSelectedTopCats = ref3[1]; // 1차 카테고리(다중)
    var ref4 = (0,react.useState)([]), searchTags = ref4[0], setSearchTags = ref4[1]; // 2차 카테고리(다중)
    // 사이즈 + 오차(기본 ±30)
    var ref5 = (0,react.useState)(""), garoInput = ref5[0], setGaroInput = ref5[1];
    var ref6 = (0,react.useState)(""), seroInput = ref6[0], setSeroInput = ref6[1];
    var ref7 = (0,react.useState)(""), highInput = ref7[0], setHighInput = ref7[1];
    var ref8 = (0,react.useState)("30"), sizeTol = ref8[0], setSizeTol = ref8[1];
    // 정렬
    var ref9 = (0,react.useState)("nameAsc"), sortKey = ref9[0], setSortKey = ref9[1];
    // 카테고리별 더보기 상태
    var ref10 = (0,react.useState)({}), catShowCounts = ref10[0], setCatShowCounts = ref10[1];
    // URL 변경 시 필터 일부 초기화 + 더보기 리셋
    (0,react.useEffect)(function() {
        resetFilters({
            keepKeyword: true,
            keepSort: true
        });
        setCatShowCounts({});
    }, [
        router === null || router === void 0 ? void 0 : router.asPath
    ]);
    // productGroups 변경 시 카테고리별 초기 표시 개수 설정
    (0,react.useEffect)(function() {
        if (!hasData) return;
        setCatShowCounts(function(prev) {
            var next = _objectSpread({}, prev);
            Object.keys(productGroups).forEach(function(k) {
                if (typeof next[k] !== "number") next[k] = INITIAL_PAGE;
            });
            return next;
        });
    }, [
        productGroups,
        hasData
    ]);
    var CONTROL_HEIGHT = 36;
    var controlStyle = {
        height: CONTROL_HEIGHT,
        padding: "6px 10px",
        border: "1px solid #e5e7eb",
        borderRadius: 8
    };
    var resetFilters = function() {
        var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _keepKeyword = ref.keepKeyword, keepKeyword = _keepKeyword === void 0 ? false : _keepKeyword, _keepSort = ref.keepSort, keepSort = _keepSort === void 0 ? false : _keepSort;
        if (!keepKeyword) setInnerKeyword("");
        setSelectedTopCats([]);
        setSearchTags([]);
        setGaroInput("");
        setSeroInput("");
        setHighInput("");
        setSizeTol("30");
        if (!keepSort) setSortKey("nameAsc");
    };
    // ===== 유틸 =====
    var norm = function(v) {
        return (v !== null && v !== void 0 ? v : "").toString().toLowerCase().trim();
    };
    var includesAll = function(hay, needles) {
        return needles.every(function(n) {
            return hay.includes(n);
        });
    };
    var parsePositive = function(val) {
        var m = (val !== null && val !== void 0 ? val : "").toString().match(/^\s*\d+\s*$/);
        if (!m) return undefined;
        var n = Number(m[0].trim());
        return n > 0 ? n : undefined;
    };
    var sizeMatch = function(item) {
        var wantG = parsePositive(garoInput);
        var wantS = parsePositive(seroInput);
        var wantH = parsePositive(highInput);
        var tol = Number(sizeTol || 0);
        var within = function(key, want) {
            if (typeof want === "number") {
                var t = Number(item === null || item === void 0 ? void 0 : item[key]);
                if (!Number.isFinite(t)) return false;
                return Math.abs(t - want) <= tol;
            }
            return true;
        };
        return within("horizontal", wantG) && within("vertical", wantS) && within("height", wantH);
    };
    var keywordMatch = function(item) {
        var q = norm(innerKeyword);
        if (!q) return true;
        var hay = [
            item === null || item === void 0 ? void 0 : item.pname,
            item === null || item === void 0 ? void 0 : item.brand_kor,
            item === null || item === void 0 ? void 0 : item.feature,
            item === null || item === void 0 ? void 0 : item.category_tag,
            item === null || item === void 0 ? void 0 : item.pcode
        ].map(norm).join(" ");
        var tokens = q.split(/\s+/).filter(Boolean);
        return includesAll(hay, tokens);
    };
    var tagMatch = function(item) {
        if (searchTags.length === 0) return true;
        var tags = ((item === null || item === void 0 ? void 0 : item.category_tag) || "").split(",").map(function(s) {
            return s.trim();
        }).filter(Boolean);
        return tags.some(function(t) {
            return searchTags.includes(t);
        });
    };
    // 1차 카테고리 후보
    var allTopCats = (0,react.useMemo)(function() {
        return Object.keys(productGroups).sort();
    }, [
        productGroups
    ]);
    // (선택된 1차 범위 내) 평탄화
    var flatInTopScope = (0,react.useMemo)(function() {
        if (!hasData) return [];
        var keys = selectedTopCats.length ? selectedTopCats : Object.keys(productGroups);
        var acc = [];
        keys.forEach(function(k) {
            return (productGroups[k] || []).forEach(function(p) {
                return acc.push(p);
            });
        });
        return acc;
    }, [
        productGroups,
        hasData,
        selectedTopCats
    ]);
    // 2차 카테고리 후보
    var allSecondTags = (0,react.useMemo)(function() {
        var set = new Set();
        flatInTopScope.forEach(function(p) {
            ((p === null || p === void 0 ? void 0 : p.category_tag) || "").split(",").map(function(s) {
                return s.trim();
            }).filter(Boolean).forEach(function(t) {
                return set.add(t);
            });
        });
        return Array.from(set).sort();
    }, [
        flatInTopScope
    ]);
    // 그룹별 필터 + 정렬
    var filteredGroups = (0,react.useMemo)(function() {
        if (!hasData) return {};
        var applySort = function(arr) {
            var out = _toConsumableArray(arr);
            switch(sortKey){
                case "nameAsc":
                    out.sort(function(a, b) {
                        return ((a === null || a === void 0 ? void 0 : a.pname) || "").localeCompare((b === null || b === void 0 ? void 0 : b.pname) || "", "ko", {
                            numeric: true,
                            sensitivity: "base"
                        });
                    });
                    break;
                case "priceAsc":
                    out.sort(function(a, b) {
                        return Number(a.discount_price) - Number(b.discount_price);
                    });
                    break;
                case "priceDesc":
                    out.sort(function(a, b) {
                        return Number(b.discount_price) - Number(a.discount_price);
                    });
                    break;
                case "salesDesc":
                    out.sort(function(a, b) {
                        return Number(b.hit || 0) - Number(a.hit || 0);
                    });
                    break;
                case "latest":
                    out.sort(function(a, b) {
                        return new Date(b.wdate || 0) - new Date(a.wdate || 0);
                    });
                    break;
                default:
                    break;
            }
            return out;
        };
        var next = {};
        var keys = selectedTopCats.length ? selectedTopCats : Object.keys(productGroups);
        keys.forEach(function(k) {
            var src = Array.isArray(productGroups[k]) ? productGroups[k] : [];
            var filtered = src.filter(function(it) {
                return keywordMatch(it) && tagMatch(it) && sizeMatch(it);
            });
            if (filtered.length) next[k] = applySort(filtered);
        });
        return next;
    }, [
        productGroups,
        hasData,
        selectedTopCats,
        innerKeyword,
        searchTags,
        garoInput,
        seroInput,
        highInput,
        sizeTol,
        sortKey, 
    ]);
    var filteredTotal = (0,react.useMemo)(function() {
        return Object.values(filteredGroups).reduce(function(sum, arr) {
            return sum + arr.length;
        }, 0);
    }, [
        filteredGroups
    ]);
    // 토글/초기화
    var toggleTopCat = function(name) {
        return setSelectedTopCats(function(prev) {
            return prev.includes(name) ? prev.filter(function(t) {
                return t !== name;
            }) : _toConsumableArray(prev).concat([
                name
            ]);
        });
    };
    var toggleTag = function(tag) {
        return setSearchTags(function(prev) {
            return prev.includes(tag) ? prev.filter(function(t) {
                return t !== tag;
            }) : _toConsumableArray(prev).concat([
                tag
            ]);
        });
    };
    // ===== 정렬 탭 (반응형) =====
    var SortTabs = function() {
        var ref = (0,react.useState)(false), isMobile = ref[0], setIsMobile = ref[1];
        (0,react.useEffect)(function() {
            var handleResize = function() {
                return setIsMobile(window.innerWidth <= 768);
            };
            handleResize();
            window.addEventListener("resize", handleResize);
            return function() {
                return window.removeEventListener("resize", handleResize);
            };
        }, []);
        var sortOptions = [
            {
                id: "nameAsc",
                label: "\uC774\uB984\uC21C"
            },
            {
                id: "priceAsc",
                label: "\uB0AE\uC740\uAC00\uACA9"
            },
            {
                id: "priceDesc",
                label: "\uB192\uC740\uAC00\uACA9"
            },
            {
                id: "salesDesc",
                label: "\uC778\uAE30"
            },
            {
                id: "latest",
                label: "\uCD5C\uC2E0"
            }, 
        ];
        if (isMobile) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    display: "flex",
                    justifyContent: "flex-end",
                    width: "100%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                    value: sortKey,
                    onChange: function(e) {
                        return setSortKey(e.target.value);
                    },
                    style: {
                        width: "auto",
                        maxWidth: "100%",
                        padding: "6px 28px 6px 10px",
                        border: "1px solid #e5e7eb",
                        borderRadius: 8,
                        fontSize: 14,
                        color: "#374151",
                        background: "#fff",
                        whiteSpace: "nowrap",
                        appearance: "menulist"
                    },
                    children: sortOptions.map(function(opt) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: opt.id,
                            children: opt.label
                        }, opt.id);
                    })
                })
            });
        }
        var Tab = function(param) {
            var id = param.id, label = param.label;
            var active = sortKey === id;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                onClick: function() {
                    return setSortKey(id);
                },
                style: {
                    background: "transparent",
                    border: "none",
                    padding: "0 10px",
                    color: active ? "#2563eb" : "#6b7280",
                    fontWeight: active ? 700 : 500,
                    cursor: "pointer",
                    whiteSpace: "nowrap"
                },
                children: [
                    active ? "\u2713 " : "",
                    label
                ]
            });
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                display: "flex",
                alignItems: "center",
                gap: 4
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab, {
                    id: "nameAsc",
                    label: "\uC774\uB984\uC21C"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        color: "#d1d5db"
                    },
                    children: "|"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab, {
                    id: "priceAsc",
                    label: "\uB0AE\uC740\uAC00\uACA9"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        color: "#d1d5db"
                    },
                    children: "|"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab, {
                    id: "priceDesc",
                    label: "\uB192\uC740\uAC00\uACA9"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        color: "#d1d5db"
                    },
                    children: "|"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab, {
                    id: "salesDesc",
                    label: "\uC778\uAE30"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        color: "#d1d5db"
                    },
                    children: "|"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab, {
                    id: "latest",
                    label: "\uCD5C\uC2E0"
                })
            ]
        });
    };
    // 카테고리별 더보기
    var showMoreProducts = function(catKey) {
        setCatShowCounts(function(prev) {
            return _objectSpread({}, prev, _defineProperty({}, catKey, Math.min((prev[catKey] || INITIAL_PAGE) + PAGE_STEP, (filteredGroups[catKey] || []).length)));
        });
    };
    // ===== 렌더 =====
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container",
            children: [
                hasData && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                textAlign: "center",
                                marginTop: 8
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                style: {
                                    fontSize: 23,
                                    fontWeight: 800,
                                    color: "#374151",
                                    marginBottom: 20
                                },
                                children: "\uAC80\uC0C9 \uACB0\uACFC\uC5D0\uC11C \uB2E4\uC2DC \uCC3E\uAE30"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                background: "#fff",
                                border: "1px solid #e5e7eb",
                                borderRadius: 10,
                                overflow: "hidden",
                                margin: "0 0 10px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterRow, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "label",
                                            children: "\uAC80\uC0C9\uC5B4"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "content",
                                            style: {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 8,
                                                flexWrap: "wrap"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "text",
                                                    value: innerKeyword,
                                                    onChange: function(e) {
                                                        return setInnerKeyword(e.target.value);
                                                    },
                                                    placeholder: "\uAC80\uC0C9\uB41C \uB370\uC774\uD130 \uB0B4 \uC7AC \uAC80\uC0C9",
                                                    style: {
                                                        height: 36,
                                                        padding: "6px 10px",
                                                        border: "1px solid #e5e7eb",
                                                        borderRadius: 8,
                                                        width: 300,
                                                        maxWidth: "100%"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    type: "button",
                                                    onClick: function() {
                                                        resetFilters();
                                                        setCatShowCounts({});
                                                    },
                                                    title: "\uD544\uD130 \uCD08\uAE30\uD654",
                                                    style: {
                                                        height: 36,
                                                        width: 36,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        border: "1px solid #e5e7eb",
                                                        borderRadius: "50%",
                                                        background: "#f9fafb",
                                                        color: "#374151",
                                                        cursor: "pointer",
                                                        fontSize: 18,
                                                        transition: "all 0.2s ease"
                                                    },
                                                    onMouseEnter: function(e) {
                                                        e.currentTarget.style.background = "#e5e7eb";
                                                        e.currentTarget.style.color = "#111827";
                                                    },
                                                    onMouseLeave: function(e) {
                                                        e.currentTarget.style.background = "#f9fafb";
                                                        e.currentTarget.style.color = "#374151";
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fi fi-rs-refresh"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterRow, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "label",
                                            children: "\uCE74\uD14C\uACE0\uB9AC"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "content",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    gap: 8,
                                                    flexWrap: "wrap"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        type: "button",
                                                        onClick: function() {
                                                            return setSelectedTopCats([]);
                                                        },
                                                        style: {
                                                            padding: "6px 10px",
                                                            borderRadius: 999,
                                                            border: "1px solid #e5e7eb",
                                                            background: selectedTopCats.length === 0 ? "#111827" : "#fff",
                                                            color: selectedTopCats.length === 0 ? "#fff" : "#111827",
                                                            fontSize: 13
                                                        },
                                                        children: "\uC804\uCCB4"
                                                    }),
                                                    allTopCats.map(function(cat) {
                                                        var active = selectedTopCats.includes(cat);
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            type: "button",
                                                            onClick: function() {
                                                                toggleTopCat(cat);
                                                                setCatShowCounts(function(prev) {
                                                                    return _objectSpread({}, prev, _defineProperty({}, cat, prev[cat] || INITIAL_PAGE));
                                                                });
                                                            },
                                                            title: cat,
                                                            style: {
                                                                padding: "6px 10px",
                                                                borderRadius: 999,
                                                                border: "1px solid #e5e7eb",
                                                                background: active ? "#111827" : "#fff",
                                                                color: active ? "#fff" : "#111827",
                                                                fontSize: 13
                                                            },
                                                            children: cat
                                                        }, cat);
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterRow, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "label",
                                            children: "\uC0C1\uC138 \uCE74\uD14C\uACE0\uB9AC"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "content",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    gap: 8,
                                                    flexWrap: "wrap"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        type: "button",
                                                        onClick: function() {
                                                            return setSearchTags([]);
                                                        },
                                                        style: {
                                                            padding: "6px 10px",
                                                            borderRadius: 999,
                                                            border: "1px solid #e5e7eb",
                                                            background: searchTags.length === 0 ? "#111827" : "#fff",
                                                            color: searchTags.length === 0 ? "#fff" : "#111827",
                                                            fontSize: 13
                                                        },
                                                        children: "\uC804\uCCB4"
                                                    }),
                                                    allSecondTags.map(function(tag) {
                                                        var active = searchTags.includes(tag);
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            type: "button",
                                                            onClick: function() {
                                                                return toggleTag(tag);
                                                            },
                                                            title: tag,
                                                            style: {
                                                                padding: "6px 10px",
                                                                borderRadius: 999,
                                                                border: "1px solid #e5e7eb",
                                                                background: active ? "#111827" : "#fff",
                                                                color: active ? "#fff" : "#111827",
                                                                fontSize: 13
                                                            },
                                                            children: tag
                                                        }, tag);
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterRow, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "label",
                                            children: "\uC0AC\uC774\uC988"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "content",
                                            style: {
                                                display: "flex",
                                                gap: 12,
                                                alignItems: "center",
                                                flexWrap: "wrap"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    style: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 6
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "\uAC00\uB85C"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "text",
                                                            inputMode: "numeric",
                                                            placeholder: "mm",
                                                            value: garoInput,
                                                            onChange: function(e) {
                                                                return setGaroInput(e.target.value);
                                                            },
                                                            style: _objectSpread({}, controlStyle, {
                                                                width: 90,
                                                                maxWidth: "100%"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    style: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 6
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "\uC138\uB85C"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "text",
                                                            inputMode: "numeric",
                                                            placeholder: "mm",
                                                            value: seroInput,
                                                            onChange: function(e) {
                                                                return setSeroInput(e.target.value);
                                                            },
                                                            style: _objectSpread({}, controlStyle, {
                                                                width: 90,
                                                                maxWidth: "100%"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    style: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 6
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "\uB192\uC774"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "text",
                                                            inputMode: "numeric",
                                                            placeholder: "mm",
                                                            value: highInput,
                                                            onChange: function(e) {
                                                                return setHighInput(e.target.value);
                                                            },
                                                            style: _objectSpread({}, controlStyle, {
                                                                width: 90,
                                                                maxWidth: "100%"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 8,
                                                        marginLeft: 8
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                        id: "sizeFilter",
                                                        name: "sizeFilter",
                                                        value: sizeTol,
                                                        onChange: function(e) {
                                                            return setSizeTol(e.target.value);
                                                        },
                                                        style: _objectSpread({}, controlStyle, {
                                                            minWidth: 90,
                                                            maxWidth: "100%",
                                                            background: "#fff"
                                                        }),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "0",
                                                                children: "\xb1 0"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "10",
                                                                children: "\xb1 10"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "20",
                                                                children: "\xb1 20"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "30",
                                                                children: "\xb1 30"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "40",
                                                                children: "\xb1 40"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "50",
                                                                children: "\xb1 50"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "60",
                                                                children: "\xb1 60"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                filteredTotal > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 12,
                        margin: "6px 0 18px",
                        whiteSpace: "nowrap",
                        minWidth: 0
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                color: "#6b7280",
                                overflow: "hidden",
                                textOverflow: "ellipsis"
                            },
                            children: [
                                "\uCD1D ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    className: "text-brand",
                                    children: filteredTotal.toLocaleString()
                                }),
                                "\uAC1C"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                flexShrink: 0
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SortTabs, {})
                        })
                    ]
                }),
                renderFilteredGroups(filteredGroups, hasCommunity, searchList, cateViewStats, moreProducts, dummyList, catShowCounts, showMoreProducts, suggestions, handleSuggestClick, // ✅ 이동 함수 & router 전달
                moveToDetail, router)
            ]
        })
    });
};
function renderFilteredGroups(filteredGroups, hasCommunity, searchList, cateViewStats, moreProducts, dummyList, catShowCounts, showMoreProducts) {
    var suggestions = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : [], onClickSuggest = arguments.length > 9 ? arguments[9] : void 0, moveToDetail = arguments.length > 10 ? arguments[10] : void 0, router = arguments.length > 11 ? arguments[11] : void 0;
    var total = Object.values(filteredGroups).reduce(function(s, a) {
        return s + a.length;
    }, 0);
    // ✅ 부모가 moveToDetail 안 줄 때 fallback
    var goDetail = function(id) {
        if (typeof moveToDetail === "function") return moveToDetail(id);
        if (!router) return;
        if (id === undefined || id === null) return;
        router.push("/esg-guide/post/".concat(encodeURIComponent(id)));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            total === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsGrid, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsSignWrapper, {
                    style: {
                        gridColumn: "1 / -1"
                    },
                    children: Array.isArray(suggestions) && suggestions.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: "\uCC3E\uC73C\uC2DC\uB294 \uC0C1\uD488\uC774 \uC5C6\uC73C\uC2E0\uAC00\uC694? \uD83D\uDE22"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                style: {
                                    margin: "14px 0 28px",
                                    fontSize: 18,
                                    color: "#374151",
                                    textAlign: "center"
                                },
                                children: [
                                    "\uC6B0\uCE21 \uD558\uB2E8\uC758 ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        style: {
                                            color: "#10b981"
                                        },
                                        children: "\uCC44\uB110\uD1A1"
                                    }),
                                    "\uC73C\uB85C \uBB38\uC758 \uC8FC\uC2DC\uBA74",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "\uCE5C\uC808\uD788 \uB3C4\uC640\uB4DC\uB9AC\uAC70\uB098 ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        style: {
                                            color: "#10b981"
                                        },
                                        children: "\uB9DE\uCDA4\uC81C\uC791 \uC11C\uBE44\uC2A4"
                                    }),
                                    "\uB97C \uC548\uB0B4\uD574\uB4DC\uB9B4\uAC8C\uC694 \uD83D\uDCAC"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    color: "#6b7280",
                                    marginBottom: 20,
                                    fontSize: 17,
                                    textAlign: "center"
                                },
                                children: "\uC544\uB798 \uCD94\uCC9C \uD0A4\uC6CC\uB4DC \uC911 \uCC3E\uC73C\uC2DC\uB294 \uC0C1\uD488\uC744 \uD074\uB9AD\uD574\uBCF4\uC138\uC694"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    display: "grid",
                                    gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
                                    justifyContent: "center",
                                    gap: 12,
                                    margin: "0 auto 36px",
                                    maxWidth: 820,
                                    width: "100%"
                                },
                                children: suggestions.map(function(kw, idx) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        onClick: function() {
                                            return onClickSuggest && onClickSuggest(kw);
                                        },
                                        title: kw,
                                        style: {
                                            width: "100%",
                                            minHeight: 56,
                                            padding: "12px 16px",
                                            borderRadius: 30,
                                            border: "1px solid #e5e7eb",
                                            background: "#fff",
                                            cursor: "pointer",
                                            fontSize: 15,
                                            color: "#111827",
                                            transition: "all 0.2s ease",
                                            boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            textAlign: "center",
                                            wordBreak: "break-word"
                                        },
                                        onMouseEnter: function(e) {
                                            e.currentTarget.style.background = "#f9fafb";
                                            e.currentTarget.style.transform = "translateY(-2px)";
                                            e.currentTarget.style.boxShadow = "0 3px 6px rgba(0,0,0,0.08)";
                                        },
                                        onMouseLeave: function(e) {
                                            e.currentTarget.style.background = "#fff";
                                            e.currentTarget.style.transform = "none";
                                            e.currentTarget.style.boxShadow = "0 1px 2px rgba(0,0,0,0.04)";
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                display: "-webkit-box",
                                                WebkitBoxOrient: "vertical",
                                                WebkitLineClamp: 2,
                                                overflow: "hidden",
                                                lineHeight: 1.3,
                                                maxHeight: "2.6em"
                                            },
                                            children: kw
                                        })
                                    }, "".concat(kw, "-").concat(idx));
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "btn",
                                href: "/customizing/customizing-products/",
                                children: "\uB9DE\uCDA4\uC81C\uC791 \uBC14\uB85C\uAC00\uAE30"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: "\uC544\uC27D\uAC8C\uB3C4 \uC870\uAC74\uC5D0 \uB9DE\uB294 \uC0C1\uD488\uC744 \uCC3E\uC9C0 \uBABB\uD588\uC5B4\uC694 \uD83D\uDE25"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                style: {
                                    fontSize: 18,
                                    color: "#4b5563",
                                    lineHeight: 1.9,
                                    marginBottom: 36,
                                    textAlign: "center"
                                },
                                children: [
                                    "\uADF8\uB798\uB3C4 \uAC71\uC815 \uB9C8\uC138\uC694! \uD83D\uDCAC",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "\uC6B0\uCE21 \uD558\uB2E8\uC758 ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        style: {
                                            color: "#10b981"
                                        },
                                        children: "\uCC44\uB110\uD1A1"
                                    }),
                                    "\uC73C\uB85C \uBB38\uC758 \uC8FC\uC2DC\uBA74 \uB2F4\uB2F9\uC790\uAC00 \uBE60\uB974\uAC8C \uB3C4\uC640\uB4DC\uB9B4\uAC8C\uC694.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "\uB610\uB294 \uC544\uB798 ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "\uB9DE\uCDA4\uC81C\uC791 \uC11C\uBE44\uC2A4"
                                    }),
                                    "\uB97C \uC774\uC6A9\uD558\uC2DC\uBA74 \uC6D0\uD558\uC2DC\uB294 \uD615\uD0DC\uB85C \uC81C\uC791\uD574\uB4DC\uB9B4 \uC218\uB3C4 \uC788\uC5B4\uC694 \u2728"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "btn",
                                href: "/customizing/customizing-products/",
                                children: "\uB9DE\uCDA4\uC81C\uC791 \uBC14\uB85C\uAC00\uAE30"
                            })
                        ]
                    })
                })
            }) : Object.keys(filteredGroups).map(function(key, i) {
                var list = filteredGroups[key] || [];
                var ref;
                var showCount = Math.min((ref = catShowCounts === null || catShowCounts === void 0 ? void 0 : catShowCounts[key]) !== null && ref !== void 0 ? ref : INITIAL_PAGE, list.length);
                var canMore = showCount < list.length;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListWraper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryTitle, {
                            children: [
                                key,
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    style: {
                                        color: "#9CA3AF",
                                        fontWeight: 400
                                    },
                                    children: [
                                        "(",
                                        list.length.toLocaleString(),
                                        "\uAC1C)"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsGrid, {
                            children: list.slice(0, showCount).map(function(item, idx) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(SingleProduct/* default */.Z, {
                                    product: item,
                                    dummyList: dummyList,
                                    listViewType: "grid"
                                }, "".concat(key, "-").concat(idx, "-").concat((item === null || item === void 0 ? void 0 : item.pcode) || (item === null || item === void 0 ? void 0 : item.pname) || idx));
                            })
                        }),
                        canMore && /*#__PURE__*/ (0,jsx_runtime.jsxs)(MoreBtn, {
                            onClick: function() {
                                return showMoreProducts(key);
                            },
                            children: [
                                key,
                                " \uB354\uBCF4\uAE30"
                            ]
                        })
                    ]
                }, i);
            }),
            hasCommunity && function() {
                var ref, ref12;
                var all = searchList.community.data || [];
                var ref13;
                var cStart = (ref13 = cateViewStats === null || cateViewStats === void 0 ? void 0 : (ref = cateViewStats.community) === null || ref === void 0 ? void 0 : ref.start) !== null && ref13 !== void 0 ? ref13 : 0;
                var ref14;
                var cLast = (ref14 = cateViewStats === null || cateViewStats === void 0 ? void 0 : (ref12 = cateViewStats.community) === null || ref12 === void 0 ? void 0 : ref12.last) !== null && ref14 !== void 0 ? ref14 : 8;
                var sliced = all.slice(cStart, cLast);
                var canMore = cLast < all.length;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListWraper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTitle, {
                            children: "\uAD00\uB828 \uAC8C\uC2DC\uBB3C"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchedCommunity, {
                            children: sliced.map(function(el, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommunityBox, {
                                    onClick: function() {
                                        return goDetail(el.id);
                                    },
                                    role: "button",
                                    tabIndex: 0,
                                    onKeyDown: function(e) {
                                        return (e.key === "Enter" || e.key === " ") && goDetail(el.id);
                                    },
                                    children: [
                                        el.thumbnail && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "thumbnail",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: el.thumbnail,
                                                alt: "\uAC8C\uC2DC\uBB3C \uC378\uB124\uC77C"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "title",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                children: el.title
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                            className: "sub_title",
                                            children: el.sub_title
                                        })
                                    ]
                                }, "".concat(el.id || i));
                            })
                        }),
                        canMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreBtn, {
                            onClick: function() {
                                return moreProducts && moreProducts("community");
                            },
                            children: "\uAC80\uC0C9\uB41C \uAC8C\uC2DC\uBB3C \uB354\uBCF4\uAE30"
                        })
                    ]
                });
            }()
        ]
    });
}
/* harmony default export */ var Search_presenter = (SearchUI);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(64384);
// EXTERNAL MODULE: ./redux/action/loading.js
var loading = __webpack_require__(19828);
// EXTERNAL MODULE: ./api/products.js
var products = __webpack_require__(81628);
// EXTERNAL MODULE: ./common/modalOverflowHook.js
var modalOverflowHook = __webpack_require__(39277);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Spinner.js
var Spinner = __webpack_require__(36968);
;// CONCATENATED MODULE: ./pages/search/index.js
function search_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function search_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return search_arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function search_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function search_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function search_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function search_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            search_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function search_toConsumableArray(arr) {
    return search_arrayWithoutHoles(arr) || search_iterableToArray(arr) || search_unsupportedIterableToArray(arr) || search_nonIterableSpread();
}
function search_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return search_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return search_arrayLikeToArray(o, minLen);
}











var SearchPage = function(param) {
    var _$isLoaded = param.isLoaded, _$isLoading = param.isLoading, dummyList = param.dummyList, loading = param.loading;
    var router = (0,next_router.useRouter)();
    var searchTerm = router.query.search;
    // 리스트 타입
    var ref7 = (0,react.useState)("grid"), viewType = ref7[0], setViewType = ref7[1];
    // 검색 리스트
    var ref1 = (0,react.useState)({}), searchList = ref1[0], setSearchList = ref1[1];
    // total
    var ref2 = (0,react.useState)(0), searchedTotal = ref2[0], setSearchedTotal = ref2[1];
    // 추천 키워드
    var ref3 = (0,react.useState)([]), suggestions = ref3[0], setSuggestions = ref3[1];
    // 로그인 모달
    var ref4 = (0,react.useState)(false), openLoginModal = ref4[0], setOpenLoginModal = ref4[1];
    var modalScollHook = (0,modalOverflowHook/* default */.Z)(openLoginModal);
    // 카테고리/커뮤니티 더보기 상태
    var ref5 = (0,react.useState)({
        community: {
            start: 0,
            last: 8
        }
    }), cateViewStats = ref5[0], setCateViewStats = ref5[1];
    var ref6 = (0,react.useState)(false), searchLoading = ref6[0], setSearchLoading = ref6[1];
    var moreProducts = function(key) {
        setCateViewStats(function(prev) {
            var ref;
            return search_objectSpread({}, prev, search_defineProperty({}, key, {
                start: 0,
                last: (((ref = prev[key]) === null || ref === void 0 ? void 0 : ref.last) || 8) + 8
            }));
        });
    };
    // 비회원 바로 구매 모달 오픈
    var handleLoginModal = function() {
        setOpenLoginModal(function(prev) {
            return !prev;
        });
    };
    // 바로 구매하기
    var purchaseDirect = function(product) {
        return function() {
            sessionStorage.setItem("directOrder", JSON.stringify([
                search_objectSpread({}, product, {
                    cnt: 1
                })
            ]));
            if (!getCookie("token") && !openLoginModal) {
                handleLoginModal();
                return;
            } else {
                document.body.style.removeProperty("overflow");
                sessionStorage.setItem("directOrder", JSON.stringify([
                    search_objectSpread({}, product, {
                        cnt: 1
                    })
                ]));
                router.push({
                    pathname: "/checkout",
                    query: {
                        type: "direct"
                    }
                });
            }
        };
    };
    var handleListViewType = function(type) {
        if (viewType === type) return;
        localStorage.setItem("P_viewType", type);
        setViewType(type);
    };
    var fetchSearchedProducts = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res, ref, ref8, ref9, ref10;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setSearchLoading(true);
                        setSearchList({});
                        setSearchedTotal(null);
                        setSuggestions([]);
                        body = search_objectSpread({
                            modes: "Search"
                        }, router.query, {
                            searchTxt: router.query.search
                        });
                        _ctx.next = 7;
                        return (0,products/* searchProducts */.s3)(body);
                    case 7:
                        res = _ctx.sent;
                        if (res.Code === "0000") {
                            ;
                            setSearchList(res.Data.Rows);
                            setSearchedTotal(res.Data.Rows.total_count);
                            ;
                            setSuggestions((ref10 = res === null || res === void 0 ? void 0 : (ref = res.Data) === null || ref === void 0 ? void 0 : (ref8 = ref.KeyWords) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.data) === null || ref9 === void 0 ? void 0 : ref9.suggestions) !== null && ref10 !== void 0 ? ref10 : []);
                        } else {
                            setSearchList({
                                data: [],
                                total_count: 0
                            });
                            setSuggestions([]);
                        }
                        setSearchLoading(false);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchSearchedProducts() {
            return _ref.apply(this, arguments);
        };
    }();
    // ✅ 수정 포인트: 새 탭(popup) 대신 라우터로 이동
    var moveToDetail = function(id) {
        if (!id && id !== 0) {
            console.warn("[moveToDetail] invalid id:", id);
            return;
        }
        // 실제 라우팅 규칙이 달라지면 여기 경로만 바꾸면 됩니다.
        var href = "/esg-guide/post/".concat(encodeURIComponent(id));
        router.push(href);
    };
    (0,react.useEffect)(function() {
        var ref, ref11, ref12, ref13;
        if (!router.isReady) return;
        if (localStorage.getItem("P_viewType")) {
            setViewType(localStorage.getItem("P_viewType"));
        }
        if (((ref = router.query) === null || ref === void 0 ? void 0 : ref.search) || ((ref11 = router.query) === null || ref11 === void 0 ? void 0 : ref11.garo) || ((ref12 = router.query) === null || ref12 === void 0 ? void 0 : ref12.sero) || ((ref13 = router.query) === null || ref13 === void 0 ? void 0 : ref13.high)) {
            fetchSearchedProducts();
        }
    }, [
        router.query,
        router.isReady
    ]);
    (0,react.useEffect)(function() {
        if (searchList.data) {
            if (Object.keys(searchList.data).length > 0) {
                var keys = search_toConsumableArray(Object.keys(searchList.data));
                var temp = search_objectSpread({}, cateViewStats);
                if (keys.length > 0) {
                    keys.forEach(function(key) {
                        temp = search_objectSpread({}, temp, search_defineProperty({}, key, {
                            start: 0,
                            last: 8
                        }));
                    });
                }
                setCateViewStats(temp);
            }
            setSearchLoading(false);
        }
    }, [
        searchList
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: "/search"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
                noBreadcrumb: "d-none",
                children: [
                    searchLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "d-flex align-items-center justify-content-center",
                            style: {
                                minHeight: "500px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                animation: "border",
                                role: "status"
                            })
                        })
                    }),
                    (searchList === null || searchList === void 0 ? void 0 : searchList.data) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_presenter, {
                        router: router,
                        viewType: viewType,
                        handleListViewType: handleListViewType,
                        searchList: searchList,
                        searchTerm: searchTerm,
                        dummyList: dummyList,
                        purchaseDirect: purchaseDirect,
                        searchedTotal: searchedTotal,
                        moveToDetail: moveToDetail,
                        moreProducts: moreProducts,
                        cateViewStats: cateViewStats,
                        suggestions: suggestions
                    })
                ]
            }),
            openLoginModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestLoginModal, {
                handleLoginModal: handleLoginModal,
                openLoginModal: openLoginModal,
                purchaseDirect: purchaseDirect,
                product: JSON.parse(sessionStorage.getItem("directOrder"))[0],
                cnt: 1
            })
        ]
    });
};
var mapStateToProps = function(state) {
    return {
        dummyList: state.dummyList,
        loading: state.loading
    };
};
var mapDidpatchToProps = {
    isLoaded: loading/* isLoaded */.k,
    isLoading: loading/* isLoading */.h
};
/* harmony default export */ var search = ((0,es/* connect */.$j)(mapStateToProps, mapDidpatchToProps)(SearchPage));


/***/ }),

/***/ 43181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ openQuickView; },
/* harmony export */   "z": function() { return /* binding */ closeQuickView; }
/* harmony export */ });
/* harmony import */ var _constants_actionTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46330);

var openQuickView = function(product) {
    return function(dispatch) {
        dispatch({
            type: _constants_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .OPEN_QUICK_VIEW */ .GS,
            payload: {
                product: product
            }
        });
    };
};
var closeQuickView = function() {
    return function(dispatch) {
        dispatch({
            type: _constants_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .CLOSE_QUICK_VIEW */ .fJ
        });
    };
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9199,2511,9774,2888,179], function() { return __webpack_exec__(27646); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);